import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { User } from '../interfaces/User.interface'
import { saveStateToStorage } from 'helpers/localStorageHelper'

const USER_STORAGE_KEY = 'user'

export default function useCurrentUser(initialValue = undefined) {
  const user = useSelector((state: any) => state.user)
  const [currentUser, setCurrentUser] = useState<User | undefined>(user)
  const authenticationState = useSelector((state: any) => state.authentication)
  const isUserLoggedIn = authenticationState?.loggedIn

  useEffect(() => {
    if (isUserLoggedIn) {
      setCurrentUser(user)
    } else {
      setCurrentUser(undefined)
    }
    return () => {
      setCurrentUser(undefined)
    }
  }, [isUserLoggedIn, user])

  useEffect(() => {
    if (JSON.stringify(user) !== JSON.stringify(currentUser)) {
      setCurrentUser(user)
      saveStateToStorage(USER_STORAGE_KEY, user)
    }
  }, [user, currentUser])

  return currentUser || initialValue
}
